'use strict';

angular.module('adminRoutes', ['AdminControllers',
                               'services.authenticatedUser'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('administration', {
            url: '/Administration',
            templateUrl: require('./admin.tpl.html'),
            controller: 'AdminController',
            resolve: {
                authenticatedUser: [
                    'authenticatedUserService', function(service) {
                        return service.getAuthenticatedUser();
                    }
                ],
            }
        });
}]);